type ProductDraft = Record<string, unknown>;

/** Serialize writes and send only fields changed since the last successful save. */
export function createProductAutosave(initial: ProductDraft, save: (patch: ProductDraft) => Promise<void>) {
  let baseline = structuredClone(initial);
  let latest = baseline;
  let pending: Promise<void> | null = null;

  const flush = (draft: ProductDraft): Promise<void> => {
    latest = structuredClone(draft);
    if (pending) return pending;
    pending = (async () => {
      // Defer until pending is assigned, even when there are no changes.
      await Promise.resolve();
      while (true) {
        const snapshot = latest;
        const patch = Object.fromEntries(Object.entries(snapshot).filter(
          ([key, value]) => JSON.stringify(value) !== JSON.stringify(baseline[key]),
        ));
        if (Object.keys(patch).length === 0) return;
        await save(patch);
        baseline = snapshot;
      }
    })().finally(() => { pending = null; });
    return pending;
  };
  return { flush };
}
